import React from "react";
import { createRoot } from "react-dom/client";
import { BaseProvider, LightTheme } from "baseui";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
import { HelmetProvider } from "react-helmet-async";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";

Chart.register(ArcElement, Tooltip, Legend);

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/font-awesome/css/all.css";

const engine = new Styletron();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={LightTheme}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BaseProvider>
  </StyletronProvider>
);

serviceWorker.unregister();
